import UploadTemplate from './UploadTemplate.jsx'

export default UploadTemplate
